import { useAuth } from '../../../contexts/AuthContext';
import { AuthGuard } from '../../auth/components/AuthGuard';
import { SearchResults } from '../components/SearchResult';
import { Helmet } from 'react-helmet-async'

function SearchPage() {
      const { isLoading, isAuthenticated, isInitialized } = useAuth();
    
  return (
    <>
      <Helmet>
        <title>Buscar eventos | Punta Tech Meetup</title>
        <meta name="description" content="Explorá eventos por ciudad, categoría y fecha." />
      </Helmet>
      <AuthGuard
        requireAuth={false} isLoading={isLoading} isAuthenticated={isAuthenticated} isInitialized={isInitialized}
      >
        <SearchResults />
      </AuthGuard>
    </>
  );
}

SearchPage.displayName = "Punta Tech Meetup - Resultados de búsqueda";
export default SearchPage;